import { render, staticRenderFns } from "./SchemaTable.vue?vue&type=template&id=ba8639f4&scoped=true"
import script from "./SchemaTable.vue?vue&type=script&lang=js"
export * from "./SchemaTable.vue?vue&type=script&lang=js"
import style0 from "./SchemaTable.vue?vue&type=style&index=0&id=ba8639f4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba8639f4",
  null
  
)

export default component.exports